import { createContext } from "react";

export const ChatAvatarContext = createContext<string | undefined>(undefined);
